module.exports = __webpack_public_path__ + "static/media/cover-cile.7591a010.png";